/* INN: 1. box floating over image also wanted on mobile
 *      2. smoother transitions with fade-over effect (also on UiO)
 */

class MediaWide {
  articleMediaFullscreen() {
    const fullscreenMediaContainersAll = document.querySelectorAll(".media-fullscreen");

    function nextUntil(elem, selector, includeCurrent) {
    	var siblings = [];
      if((typeof includeCurrent !== "boolean" || includeCurrent === false) && typeof elem != "undefined") {
        elem = elem.nextElementSibling;
      }
    	while (elem) {
    		if (typeof selector != "undefined" && elem.matches(selector)) break;
    		siblings.push(elem);
    		elem = elem.nextElementSibling;
    	}
    	return siblings;
    }

    function prevUntil(elem, selector, includeCurrent) {
      var siblings = [];
      if((typeof includeCurrent !== "boolean" || includeCurrent === false) && typeof elem != "undefined") {
        elem = elem.previousElementSibling;
      }
      while (elem) {
        if (typeof selector != "undefined" && elem.matches(selector)) break;
        siblings.push(elem);
        elem = elem.previousElementSibling;
      }
      return siblings;
    }

    // Quick pass-through adding has-caption class (for setting sticky-media correcly on all in row of these when in viewport in scroll)
    fullscreenMediaContainersAll.forEach(fullscreenMediaContainer => {
      const caption = fullscreenMediaContainer.querySelector("figcaption");
      if (fullscreenMediaContainer.contains(caption)) {
        fullscreenMediaContainer.classList.add("has-caption");
      }
    });

    window.pausedScrollingStickyMedia = null;
    fullscreenMediaContainersAll.forEach((fullscreenMediaContainer, i) => {
      // if contains caption, enable sticky effect
      if (fullscreenMediaContainer.classList.contains("has-caption")) {
        const fullscreenMedia = fullscreenMediaContainer.querySelector("img, video");
 
        // on scroll..
        window.addEventListener("scroll", function() {
          // Clear timeout and remove stopped scrolling class for active sticky-media (row of medias)
          clearTimeout(window.pausedScrollingStickyMedia);
          const activeStickyMedia = document.querySelector(".sticky.sticky-media");
          if(activeStickyMedia) {
            activeStickyMedia.classList.remove("sticky-media-active-paused-scrolling");
          }

          const fullscreenMediaHeight = fullscreenMedia.getBoundingClientRect().height;
          const fullscreenMediaContainerTop = fullscreenMediaContainer.getBoundingClientRect().top;
          const next = fullscreenMediaContainer.nextElementSibling;
          const prev = fullscreenMediaContainer.previousElementSibling;

          // Make image/video sticky when row of them is in viewport
          if (fullscreenMediaContainerTop < 0) {
            if(next.classList.contains("media-fullscreen") && next.querySelector("figcaption")) {
              nextUntil(fullscreenMediaContainer, ":not(.media-fullscreen.has-caption)", true).forEach(function(elm) {
                elm.classList.add("sticky-media");
              });
            }
          }
          // Remove if row of them is above viewport
          if (fullscreenMediaContainerTop >= 0) {
            if(!prev || !prev.classList.contains("media-fullscreen") || !prev.querySelector("figcaption")) {
              nextUntil(fullscreenMediaContainer, ":not(.sticky-media)", true).forEach(function(elm) {
                elm.classList.remove("sticky-media");
              });
            }
          }

          // if media container is just past viewport top but not further past than media height..
          if (fullscreenMediaContainerTop < 0 && fullscreenMediaContainerTop > -fullscreenMediaHeight) {
            fullscreenMediaContainer.classList.add("sticky");
          } else {
            fullscreenMediaContainer.classList.remove("sticky");
          }

          // if media container is further past viewport top than media height..
          if (fullscreenMediaContainerTop < -fullscreenMediaHeight) {
            fullscreenMediaContainer.classList.add("scrolled-past");

            // Remove sticky-media when scrolled past row of them
            if(!next.classList.contains("media-fullscreen") || !next.querySelector("figcaption")) {
              prevUntil(fullscreenMediaContainer, ":not(.sticky-media)", true).forEach(function(elm) {
                elm.classList.remove("sticky-media");
              });
            }
          } else {
            fullscreenMediaContainer.classList.remove("scrolled-past");
          }

          // If not scrolled for 1s, make so active .sticky-media video can be stopped/paused
          // (if this value is smaller it can be problem with the 1s animation/fade, can be set to 200ms if required
          // to to be clicked more instantly but then you can get hard fade for videos in media row if stops scrolling
          // inside the transition)
          window.pausedScrollingStickyMedia = setTimeout(() => {
            const activeStickyMedia = document.querySelector(".sticky.sticky-media");
            if(activeStickyMedia) {
              activeStickyMedia.classList.add("sticky-media-active-paused-scrolling");
            }
          }, 1000); 
        });
      }
    });
  }

  pageTopMedia() {
    const pageTopRow = document.querySelector(".grid-container.page-top");
    if (pageTopRow) {
      document.body.classList.add("has-page-top-row");
    }
    const pageTopRowWhite = document.querySelector(".grid-container.page-top-white");
    if (pageTopRowWhite) {
      document.body.classList.add("has-page-top-row-white");
    }
  }

  backgroundVideo() {
    const bgVideoContainers = document.querySelectorAll(".vrtx-background-video");
    bgVideoContainers.forEach(bgVideoContainer => {
      // pause-video button
      const bgVideoPauseButton = bgVideoContainer.querySelector(".pause-video");
      bgVideoPauseButton.addEventListener("click", pauseVideo);

      const bgVideo = bgVideoContainer.querySelector("video");
      bgVideo.addEventListener("click", pauseVideo);

      function pauseVideo() {
        bgVideoPauseButton.classList.toggle("paused");

        if (bgVideo.paused) {
          bgVideo.play();
        }
        else {
          bgVideo.pause();
        }
      }
    });
  }
}
export default new MediaWide;